<mat-tab-group class="reset-tabs" dynamicHeight>
  @if (hasAttestorVerification()) {
    <mat-tab [label]="'uboOrderDetailsTabGroup.attestorDetails' | transloco">
      <mat-card class="results-content card-margin">
        <mat-card-content>
          @if (attestor?.contactDetails?.phoneNumber) {
            <div class="flex-container">
              <span class="flex-item-2 text-faded">{{ 'uboOrderDetailsTabGroup.attestorPhone' | transloco }}</span>
              <span class="flex-item-2">{{ attestor!.contactDetails!.phoneNumber }}</span>
            </div>
          }
          @if (formatAttestorAddress($safeNavigationMigration(attestor?.contactDetails?.address)); as addr) {
            @if (addr) {
              <div class="flex-container">
                <span class="flex-item-2 text-faded">{{ 'uboOrderDetailsTabGroup.attestorAddress' | transloco }}</span>
                <span class="flex-item-2">{{ addr }}</span>
              </div>
            }
          }
          @if (attestor?.dateOfBirth) {
            <div class="flex-container">
              <span class="flex-item-2 text-faded">{{ 'uboOrderDetailsTabGroup.attestorDateOfBirth' | transloco }}</span>
              <span class="flex-item-2">{{ attestor!.dateOfBirth | date: 'yyyy-MM-dd' }}</span>
            </div>
          }
          <div class="flex-container">
            <span class="flex-item-2 text-faded">{{ 'uboOrderDetailsTabGroup.attestorVerification' | transloco }}</span>
            <span class="flex-item-2">{{ getReadableIDVMethod() }}</span>
          </div>
          @if (this.orderIdvDetails?.idvConsented != null) {
            <div class="flex-container">
              <span class="flex-item-2 text-faded">{{ 'uboOrderDetailsTabGroup.idvConsented' | transloco }}</span>
              <span class="flex-item-2">{{ orderIdvDetails!.idvConsented ? "Yes" : "No" }}</span>
            </div>
          }
          @if (showIdVStatus()) {
            <div class="flex-container">
              <span class="flex-item-2 text-faded">{{ 'uboOrderDetailsTabGroup.attestorVerificationStatus' | transloco }}</span>
              <span class="flex-item-2">
                {{ getReadableIDVStatus() }}
                @if (showIdvResults()){
                  <mat-icon class="inline-icon" [appIdvTooltip]="orderIdvDetails">info</mat-icon>
                }
              </span>
            </div>
          }
        </mat-card-content>
      </mat-card>
    </mat-tab>
  }
  <mat-tab [label]="'uboOrderDetailsTabGroup.general' | transloco">
    <lib-ubo-overview [order]="order" [results]="results"></lib-ubo-overview>
  </mat-tab>
  @if (!order.ultimateBeneficialOwnershipRequest?.isUnregisteredEntity) {
  <mat-tab>
    <ng-template mat-tab-label>
      {{ 'uboOrderDetailsTabGroup.changes' | transloco }}
      @if (order.jurisdiction === '_F' && (order.orderChanges?.length ?? 0) > 0) {
        <mat-icon class="icon-warning padding-left-15">warning</mat-icon>
      }
    </ng-template>
    <lib-ubo-change-details [order]="order" [admin]="admin"></lib-ubo-change-details>
  </mat-tab>
  }
  @if (order.ultimateBeneficialOwnershipRequest?.requireSigningAuthority && 
    (uiConfiguration?.hasSigningAuthorityParties ?? false)) {
    <mat-tab>
    <ng-template mat-tab-label>
      {{ 'uboOrderDetailsTabGroup.signingAuthorities' | transloco }}
    </ng-template>
    <lib-parties-list
      partyTypeTitle="Signing Authority"
      [order]="order"
      [observableParties$]="parties$"
      class="flex-item"
      [isEditable]="false"
      [businessPartyType]="signingAuthorityPartyType"
      [individualPartyType]="signingAuthorityPartyType"
      [uiConfiguration]="uiConfiguration!.signingAuthorityConfiguration!">
    </lib-parties-list>
  </mat-tab>
  }
  <mat-tab>
    <ng-template mat-tab-label>
      {{ 'uboOrderDetailsTabGroup.shareholders' | transloco }}
      @if(shouldShowBeneficialOwnersAlert()) {
        <mat-icon class="icon-warning padding-left-15">warning</mat-icon>
      }
    </ng-template>
    <lib-ubo-beneficial-owners-review [admin]="admin" [order]="order"></lib-ubo-beneficial-owners-review>
  </mat-tab>
  @if (order.ultimateBeneficialOwnershipRequest?.questions?.length) {
    <mat-tab [label]="'common.labels.financialRiskQuestions' | transloco">
      <lib-ubo-financial-risk-questions [order]="order"></lib-ubo-financial-risk-questions>
    </mat-tab>
  }
  @if (order.ultimateBeneficialOwnershipRequest?.documents?.length) {
    <mat-tab [label]="'common.labels.supportingBusinessDocuments' | transloco">
      <lib-ubo-supporting-business-documents [order]="order"></lib-ubo-supporting-business-documents>
    </mat-tab>
  }
</mat-tab-group>